var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import * as React from "react";
import { DivFadeinCss } from "./common";
import "./version";
import { observer } from "mobx-react";
var GITHUB_LINK = "https://github.com/roginvs/space-rangers-quest";
var PIKABU_LINK = "https://pikabu.ru/story/kvestyi_iz_kosmicheskikh_reyndzherov_v_brauzere_5526211";
var AboutTabContainer = /** @class */ (function (_super) {
    __extends(AboutTabContainer, _super);
    function AboutTabContainer() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    AboutTabContainer.prototype.render = function () {
        var store = this.props.store;
        var l = store.l;
        return (React.createElement(DivFadeinCss, { key: "about", className: "text-center container my-3" },
            React.createElement("h5", { className: "mb-3", style: { wordWrap: "break-word" } },
                React.createElement("a", { href: GITHUB_LINK }, GITHUB_LINK)),
            React.createElement("div", { className: "mb-3" },
                React.createElement("div", null, l.linkForBugreports),
                React.createElement("div", { style: { wordWrap: "break-word" } },
                    React.createElement("a", { href: PIKABU_LINK }, PIKABU_LINK))),
            React.createElement("div", { className: "mb-3" },
                l.builtAt,
                " ",
                new Date(__VERSION__).toLocaleString())));
    };
    AboutTabContainer = __decorate([
        observer
    ], AboutTabContainer);
    return AboutTabContainer;
}(React.Component));
export { AboutTabContainer };
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiYWJvdXQuanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyJhYm91dC50c3giXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6Ijs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7O0FBQUEsT0FBTyxLQUFLLEtBQUssTUFBTSxPQUFPLENBQUM7QUFDL0IsT0FBTyxFQUFVLFlBQVksRUFBRSxNQUFNLFVBQVUsQ0FBQztBQUdoRCxPQUFPLFdBQVcsQ0FBQztBQUNuQixPQUFPLEVBQUUsUUFBUSxFQUFFLE1BQU0sWUFBWSxDQUFDO0FBR3RDLElBQU0sV0FBVyxHQUFHLGdEQUFnRCxDQUFDO0FBQ3JFLElBQU0sV0FBVyxHQUNmLGlGQUFpRixDQUFDO0FBR3BGO0lBQXVDLHFDQUt0QztJQUxEOztJQTBCQSxDQUFDO0lBcEJDLGtDQUFNLEdBQU47UUFDRSxJQUFNLEtBQUssR0FBRyxJQUFJLENBQUMsS0FBSyxDQUFDLEtBQUssQ0FBQztRQUMvQixJQUFNLENBQUMsR0FBRyxLQUFLLENBQUMsQ0FBQyxDQUFDO1FBQ2xCLE9BQU8sQ0FDTCxvQkFBQyxZQUFZLElBQUMsR0FBRyxFQUFDLE9BQU8sRUFBQyxTQUFTLEVBQUMsNEJBQTRCO1lBQzlELDRCQUFJLFNBQVMsRUFBQyxNQUFNLEVBQUMsS0FBSyxFQUFFLEVBQUUsUUFBUSxFQUFFLFlBQVksRUFBRTtnQkFDcEQsMkJBQUcsSUFBSSxFQUFFLFdBQVcsSUFBRyxXQUFXLENBQUssQ0FDcEM7WUFDTCw2QkFBSyxTQUFTLEVBQUMsTUFBTTtnQkFDbkIsaUNBQU0sQ0FBQyxDQUFDLGlCQUFpQixDQUFPO2dCQUNoQyw2QkFBSyxLQUFLLEVBQUUsRUFBRSxRQUFRLEVBQUUsWUFBWSxFQUFFO29CQUNwQywyQkFBRyxJQUFJLEVBQUUsV0FBVyxJQUFHLFdBQVcsQ0FBSyxDQUNuQyxDQUNGO1lBQ04sNkJBQUssU0FBUyxFQUFDLE1BQU07Z0JBQ2xCLENBQUMsQ0FBQyxPQUFPOztnQkFBRyxJQUFJLElBQUksQ0FBQyxXQUFXLENBQUMsQ0FBQyxjQUFjLEVBQUUsQ0FDL0MsQ0FDTyxDQUNoQixDQUFDO0lBQ0osQ0FBQztJQXpCVSxpQkFBaUI7UUFEN0IsUUFBUTtPQUNJLGlCQUFpQixDQTBCN0I7SUFBRCx3QkFBQztDQUFBLEFBMUJELENBQXVDLEtBQUssQ0FBQyxTQUFTLEdBMEJyRDtTQTFCWSxpQkFBaUIifQ==